import { render } from "./InactivePass.vue?vue&type=template&id=46074e3c"
import script from "./InactivePass.vue?vue&type=script&lang=js"
export * from "./InactivePass.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__